"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_WINNER_MINIMUM_SPEND = void 0;
/**
 * Minimum spend (in account currency) an ad must reach before it can be
 * classified as a winner. Client overrides may raise this threshold, but may
 * not lower the safety floor.
 */
exports.DEFAULT_WINNER_MINIMUM_SPEND = 250;
